const regex = {
  phoneNumber:
    /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?(\d{4}|\d{3}))?$/,
  time: /[0-9]+(am|pm)( |)(-)( |)[0-9]+(am|pm)/ /** [0-9]+   Any number, (am|pm), Either am or pm, (-) hyphen in between, ( |), Space or no space */,
};

export default regex;
